import { useKitbagAuth } from '@statsbomb/kitbag-auth';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { loadableUserDetailsAtom } from '@/atoms/queries/user';
import { setQualtricsUserData } from '../qualtrics';

export const useQualtricsUserData = () => {
  const { user: auth0User } = useKitbagAuth();
  const userDetails = useAtomValue(loadableUserDetailsAtom);
  useEffect(() => {
    if (userDetails.state !== 'hasData' || !auth0User) return;
    const { user, entity } = userDetails.data.data;
    setQualtricsUserData(
      user.hudl_user_id,
      user.email,
      auth0User.given_name || user.name,
      auth0User.family_name || user.name,
      entity.entity_id,
      entity.name,
    );
  }, [userDetails.state, !!auth0User]);
};
